import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import DeviceIcon from '#component/icon/device-icon';

export const TooltipContainer = styled('div')({
  textAlign: 'left',
  minWidth: 150
});

export const Header = styled(Typography)({
  whiteSpace: 'nowrap',
  display: 'flex',
  marginLeft: '-4px',
  marginBottom: '8px',
  '& svg': {
    marginRight: 4
  }
});

export const AlertHeader = styled(Header)({
  color: '#f77061'
});

export const TimestampCnt = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  whiteSpace: 'nowrap'
}));

export const Label = styled('div', {
  shouldForwardProp: prop => prop !== 'alert'
})(({ theme, alert }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  '& p': {
    lineHeight: '26px',
    color: alert ? '#f77061' : theme.palette.common.white
  },
  ...(alert && { color: '#f77061' })
}));

export const StyledDeviceIcon = styled(DeviceIcon)(({ theme }) => ({
  marginRight: 4,
  color: `${theme.palette.common.white} !important`
}));
